/* eslint no-underscore-dangle: ["error", { "allowAfterThis": true  }] */
import { REST_URI } from 'lib/appConfig';
import { SocketChannel } from './SocketChannel';

const event = {
  CHANNEL_UPDATE: 'channel_update',
};

const ENDPOINT = `${REST_URI}/events/firstarticleinspection`;

class FAISocket {
  constructor({ companyId, machineRef, workOrderOperationRef }) {
    this.socket = new SocketChannel({
      url: ENDPOINT,
      joinParams: { companyId, machineRef, workOrderOperationRef },
    });
    this._onUpdate = null;
  }

  subscribe(onData) {
    this._onUpdate = onData;
    this.socket.on(event.CHANNEL_UPDATE, this._onUpdate);
  }

  leave() {
    if (this._onUpdate) {
      this.socket.off(event.CHANNEL_UPDATE, this._onUpdate);
    }
    this.socket.disconnect();
  }
}

export { FAISocket };
